import type { IconDefinition } from '../index.tsx';

export const iconLogOut: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconLogOut',
  icon: [
    16,
    16,
    [],
    '',
    'M0 2C0 1.44772 0.447715 1 1 1H8C8.55229 1 9 1.44772 9 2V5H4L4 11H9V14C9 14.5523 8.55229 15 8 15H1C0.447715 15 0 14.5523 0 14V2Z M11 7V4H12L16 8L12 12H11V9H6V7L11 7Z',
  ],
};
